import CardRail from '../CardRail';
import ThemeCard from '../ThemeCard';
import { useMBDContext } from '../common/MBD/useMBDContext';

import type { HotelsByStarRatingProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/HotelsByStarRatingProps';

const HotelsByStarRating = ({
  cards,
  destination,
  subtitle,
  title,
}: HotelsByStarRatingProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();

  if (!cards.length) {
    return null;
  }

  return (
    <div
      className="HotelsByStarRating"
      data-tracking-element-id={rawComponentName}
      data-tracking-common-params={buildMBDParam(rawComponentName)}
    >
      <CardRail title={title} subtitle={subtitle}>
        {(layout) =>
          cards.map((card, index) => (
            <ThemeCard
              key={card.title}
              {...card}
              index={`${layout}_${index}`}
            />
          ))
        }
      </CardRail>
    </div>
  );
};

export default HotelsByStarRating;
